import { useOpenRequestStatus } from '@hooks/Services';
import { Error, Loading } from '@organisms/Feedbacks';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { FormDataType } from './FormDataType';

type Props = {
    formData: FormDataType;
    onSubmitComplete: any;
};

const SubmitForm = (props: Props) => {
    const { formData, onSubmitComplete } = props;
    const { error, loading } = useOpenRequestStatus.useMessageStatus(formData);
    useEffect(() => {
        (!loading && !error && (onSubmitComplete()));
    });
    return (
        <FormWithStyled>
            {loading && <Loading />}
            {error && <Error />}
        </FormWithStyled>
    );
};

const FormWithStyled = styled.form`
    margin: 0;
`

export default SubmitForm;